import script from "./customers.vue?vue&type=script&setup=true&lang=ts"
export * from "./customers.vue?vue&type=script&setup=true&lang=ts"

import "./customers.vue?vue&type=style&index=0&id=077fc6cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077fc6cb"]])

export default __exports__